import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { MESSAGETYPES, sendToHost } from 'conversional-iframe-communication';
import { CommonActions, ConfigActions, JourneysSelectors, ProcessesActions, useAppDispatch, useAppSelector, } from 'conversional-journey';
import { createComponentsFromObject } from 'conversional-components';
import { useListener } from '../utils/listener';
var OPEN = {
    width: '100%',
    height: '100%',
    margin: 0,
    border: 'none',
    overflow: 'scroll',
};
var ROOT_OVERRIDE_STYLES = (_jsx("style", { children: " #root{\n      height: auto !important;\n    }" }));
var autoScalingInterval;
/**
 * Entry View
 * Toggles view/hide of the entry point
 * Usually renders it in Fullscreen mode
 */
var Inline = function (_a) {
    var onApplyStyles = _a.onApplyStyles, root = _a.root, content = _a.content, _b = _a.externalData, externalData = _b === void 0 ? {} : _b;
    var dispatch = useAppDispatch();
    var reset = function () { return dispatch(ProcessesActions.reset()); };
    var _c = React.useState('auto'), targetContainerHeight = _c[0], setTargetContainerHeight = _c[1];
    var theme = useAppSelector(JourneysSelectors.selectTheme);
    var contentConfig = root || content;
    function enableAutoscalingInterval() {
        function getRootHeight() {
            var rootElement = document.getElementById('root');
            return rootElement ? "".concat(rootElement.clientHeight, "px") : '350px';
        }
        autoScalingInterval = setInterval(function () {
            var calculatedHeight = getRootHeight();
            setTargetContainerHeight(calculatedHeight);
        }, 100);
    }
    useEffect(function () {
        // Only sends message to container if the height has actually changed.
        sendToHost.styleTargetContainer({ height: "".concat(targetContainerHeight, " !important"), transition: '200ms' }, true, true);
    }, [targetContainerHeight]);
    React.useEffect(function () {
        sendToHost.styleIframe(OPEN, true);
        onApplyStyles();
        enableAutoscalingInterval();
        dispatch(ConfigActions.setExternal({ data: externalData }));
        sendToHost.iframeOnScreen();
        return function () {
            sendToHost.iframeOffScreen();
            clearInterval(autoScalingInterval);
        };
    }, []);
    var onLogCta = function (_a) {
        var cta = _a.cta, label = _a.label;
        dispatch(CommonActions.logCta(cta, label));
    };
    useListener(MESSAGETYPES.JOURNEY_SHOW_RESULT, reset);
    useListener(MESSAGETYPES.JOURNEY_SET_CTA, onLogCta);
    return (_jsxs(_Fragment, { children: [ROOT_OVERRIDE_STYLES, contentConfig && createComponentsFromObject({ root: contentConfig })] }));
};
export default Inline;
